"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.formModified = formModified;
function formModified(newValue) {
  return (getState, dispatch) => {
    const {
      isFormModified
    } = getState();
    if (newValue !== isFormModified) {
      dispatch({
        payload: {
          newValue
        },
        type: 'formModified'
      }, true);
    }
  };
}